import { render, staticRenderFns } from "./ButtonOutlined.vue?vue&type=template&id=a2d1bdb0&"
import script from "./ButtonOutlined.vue?vue&type=script&lang=js&"
export * from "./ButtonOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports